import React from 'react';
import { ButtonWrapper } from '../../styled';
import { GridViewButton, ListViewButton } from '../../components/ActionBar/components/ViewButtons';
import { RUN_STATUS_LOG } from '../Tabs/constants';

const VisualModeButton = ({ seletedTab, showGridView, toggleView }) => {
  if (seletedTab === RUN_STATUS_LOG) return null;
  return (
    <ButtonWrapper>
    {showGridView
      ? (
        <ListViewButton showGridView={ showGridView } onToggleView={ toggleView } />
        )
      : (
        <GridViewButton showGridView={ showGridView } onToggleView={ toggleView } />
        )}
    </ButtonWrapper>
  );
};

export default VisualModeButton;
